module.exports = __webpack_public_path__ + "static/media/imgSurvey.5787cb19.svg";